import {
    fetchAvailableProducts,
    fetchRequestFields,
    createRequest
} from '../../../services/api/request';

import { fetchProfileShortInfo } from '../../../services/api/profile';

export const request = {
    namespaced: true,
    state: {
        documents: {},
        profile: {
            fields: [],
            files: [],
        },
        selectedProducts: [],
        products: [],
        searchedInnsEntity: [],
    },
    mutations: {
        saveProducts(state, products) {
            state.products = products;
        },
        saveFields(state, profileFields) {
            state.profile = profileFields;
        },
        selectedProducts(state, productIds) {
            state.selectedProducts = productIds;
        },
        saveCompany(state, company) {
            state.company = company;
        },
        resetState(state) {
            state.selectedProducts = [];
        },
        saveClientId(state, clientId){
            state.clientId = clientId;
        }
    },
    actions: {
        fetchAvailableProducts({ commit, dispatch }) {
            return fetchAvailableProducts()
                .then((res) => {

                    commit('saveProducts', res.data);

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        fetchProfile({ commit, dispatch }) {
            return fetchProfileShortInfo()
                .then((res) => {
                    commit('saveClientId', res.data.id);
                    dispatch('fetched');
                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        fetchRequestFields({ commit }, productIds) {
            return fetchRequestFields(productIds)
                .then((res) => {
                    commit('selectedProducts', productIds);
                    commit('saveFields', res.data);

                    return res;
                });
        },
        createRequest({ commit, state, dispatch }, values) {
            return createRequest({ ...values, products: state.selectedProducts })
                .then((res) => {
                    dispatch('balance/fetchBalance', null, { root: true });

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        resetState({ commit }) {
            commit('resetState');
        }
    },
    getters: {
        products({ products, clientId }) {
            //Костыль чтобы клиент ООО Атланта (a.k.a Крауэр Даниил Александрович) не видел продукты КО доп. 
            if (clientId === 33030) {
                products = products.filter((p) => ![5,24].includes(p.id))
            }
            return products;
        },
        productsObj({ products }) {
            return products.reduce((newProducts, product) => {
                newProducts[product.id] = product;
                return newProducts;
            }, {});
        },
        selectedProducts({ selectedProducts }) {
            return selectedProducts;
        },
        fields({ profile }) {
            return profile.fields;
        },
        total({ selectedProducts }, { productsObj }) {
            return selectedProducts.reduce((total, id) => {
                return productsObj[id].freeCount
                    ? total
                    : total + productsObj[id].cost;
            }, 0);
        },
        isIndividual({ selectedProducts }, { productsObj }) {
            return !!selectedProducts.length && productsObj[selectedProducts[0]].isIndividual;
        },

        isIdentificationRequired({ selectedProducts }, { productsObj }) {
            return !!selectedProducts.length && productsObj[selectedProducts[0]].identificationRequired;
        }
    },
};



// WEBPACK FOOTER //
// ./src/modules/home/request/store.js